/**
 * @generated SignedSource<<7baaa4a554dbb72fc5296046c2e38125>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DashboardTemplateQuery$variables = Record<PropertyKey, never>;
export type DashboardTemplateQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"DashboardTemplate_query">;
};
export type DashboardTemplateQuery = {
  response: DashboardTemplateQuery$data;
  variables: DashboardTemplateQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "DashboardTemplateQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "DashboardTemplate_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "DashboardTemplateQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Candidate",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "_id",
            "storageKey": null
          },
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "File",
            "kind": "LinkedField",
            "name": "profileImage",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "height",
                    "value": 50
                  },
                  {
                    "kind": "Literal",
                    "name": "width",
                    "value": 50
                  }
                ],
                "kind": "ScalarField",
                "name": "url",
                "storageKey": "url(height:50,width:50)"
              },
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalDocumentsByStatus",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "company",
        "args": null,
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "companyDomainName",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nameFriendly",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "File",
            "kind": "LinkedField",
            "name": "logo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "fitIn",
                    "value": true
                  }
                ],
                "kind": "ScalarField",
                "name": "url",
                "storageKey": "url(fitIn:true)"
              },
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ec91cf8bdd34a6157b8eb2660ac43d33",
    "id": null,
    "metadata": {},
    "name": "DashboardTemplateQuery",
    "operationKind": "query",
    "text": "query DashboardTemplateQuery {\n  ...DashboardTemplate_query\n}\n\nfragment Candidate_me on Candidate {\n  id\n  name\n  email\n  profileImage {\n    url(height: 50, width: 50)\n    id\n  }\n}\n\nfragment DashboardTemplate_query on Query {\n  me {\n    _id\n    name\n    email\n    id\n  }\n  company: companyDomainName {\n    id\n    name\n  }\n  ...Menu_query\n  ...Sidebar_query\n}\n\nfragment HeaderLogo_company on Company {\n  nameFriendly\n  logo {\n    url(fitIn: true)\n    id\n  }\n}\n\nfragment Menu_query on Query {\n  me {\n    id\n    ...Candidate_me\n  }\n  company: companyDomainName {\n    id\n    ...HeaderLogo_company\n  }\n}\n\nfragment Sidebar_query on Query {\n  me {\n    totalDocumentsByStatus\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "617adceeace62b8a3a109bb703698c99";

export default node;
